module.exports = __webpack_public_path__ + "img/landliebe-6361.26504cf0.jpeg";